module.exports = __webpack_public_path__ + "img/houseLighted.8a56e58e.svg";